import React from 'react';
import classNames from 'classnames';

import PropTypes from 'prop-types';

import OutputText from '@ey/canvascoreservices/OutputText';

import Button from '../../CoreWrappers/Button';
import StyledSelector from './StyledSelector';
import StyledPanelSelector from './StyledPanelSelector';
import HrVert from '../Hr/HrVert';
import HrAlt from '../Hr/HrAlt';

const PanelSelector = ({title, description, items, value = null, onClick = null, modalTriggerComponent}) => {
	const renderItem = ({id, count, label, inactive, separator}) => {
		if (separator) return <HrVert />;

		const isActive = value === id;

		const props = {
			variant: 'text-alt',
			className: classNames({active: isActive})
		};

		if (!inactive && onClick) props.onClick = () => onClick(id);
		if (inactive) props.variant = 'text';

		return (
			<Button {...props}>
				<OutputText h3 className="count">
					{count}
				</OutputText>
				<OutputText useTypography={false} ellipsis title={label}>
					{label}
				</OutputText>
			</Button>
		);
	};

	return (
		<StyledPanelSelector>
			{title && <OutputText h6>{title}</OutputText>}
			{description && (
				<OutputText body2 light className="description">
					{description}
				</OutputText>
			)}
			<StyledSelector>{items?.map(renderItem)}</StyledSelector>
			<HrAlt $color="--neutrals-200" />
			{modalTriggerComponent}
		</StyledPanelSelector>
	);
};

PanelSelector.prototype = {
	title: PropTypes.string,
	description: PropTypes.string,
	items: PropTypes.array,
	value: PropTypes.string,
	onClick: PropTypes.func
};

export default PanelSelector;
